import { IAdminHeaderLogoProps } from '@framework/theme/src/admin/AdminHeaderLogo';
import { HeaderLogo } from '@framework/ui';
import { down } from 'styled-breakpoints';
import styled, { useTheme } from 'styled-components';

const LogoWrapper = styled.div`
  width: 123px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: start;

  ${down('sm')} {
    max-width: 80px;
  }
`;

/**
 * Logo principale dell'applicativo.
 */
export function AdminHeaderLogo(props: IAdminHeaderLogoProps) {
  const theme = useTheme();

  return <HeaderLogo {...theme} logoWrapperComponent={LogoWrapper} />;
}
